import React from 'react'
import Grid from '@mui/material/Grid'

import { Delete, Edit } from '@mui/icons-material'
import { StyledCard, DeleteCorner, EditCorner, StyledImg } from './styles'
import { ModalType } from '../../types'

interface Props {
   handleModalType: (type: ModalType) => void
}

export default function CoopCard({ handleModalType }: Props) {
   return (
      <Grid size={{ xs: 12, sm: 4, md: 4, lg: 3, xl: 2 }}>
         <StyledCard>
            <DeleteCorner onClick={() => handleModalType('delete')}>
               <Delete />
            </DeleteCorner>
            <EditCorner onClick={() => handleModalType('edit')}>
               <Edit />
            </EditCorner>
            <StyledImg src={`${process.env.REACT_APP_FILES_URL}/img/integrations/baselinker.png`} alt="Baselinker" />
         </StyledCard>
      </Grid>
   )
}
